import { render, staticRenderFns } from "./WholesalersView.vue?vue&type=template&id=f57725b2"
import script from "./WholesalersView.vue?vue&type=script&lang=ts"
export * from "./WholesalersView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports